import { CarCategory } from '@shared/models/car-category.model';
import * as fromActions from '../actions/car-hire-categories.actions';

export interface CarCategoriesState {
  results: Array<CarCategory>;
}

export const initialState: CarCategoriesState = {
  results: [],
};

export function reducer(state = initialState, action: fromActions.CarCategoriesActions): CarCategoriesState {
  switch (action.type) {
    case fromActions.GET_CAR_CATEGORIES_SUCCESS: {
      const results = action.payload.car_categories;

      return {
        ...state,
        results,
      };
    }
    default:
      return state;
  }
}
